import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h1 style={{ textAlign: 'center', fontWeight: '700', fontSize: '100px', color: 'red'}}>404!</h1>
        </div>
    );
};

export default NoMatch;